import { Component } from '@angular/core';

import { ThemedComponent } from '../../shared/theme-support/themed.component';
import { TopHeaderComponent } from './top-header.component';

/**
 * Themed wrapper for TopHeaderComponent
 */
@Component({
  selector: 'ds-top-header',
  styleUrls: [],
  templateUrl: '../../shared/theme-support/themed.component.html',
  standalone: true,
  imports: [TopHeaderComponent],
})
export class ThemedTopHeaderComponent extends ThemedComponent<TopHeaderComponent> {
  protected getComponentName(): string {
    return 'TopHeaderComponent';
  }

  protected importThemedComponent(themeName: string): Promise<any> {
    return import(`../../../themes/${themeName}/app/header/top-header/top-header.component`);
  }

  protected importUnthemedComponent(): Promise<any> {
    return import(`./top-header.component`);
  }
}
